import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-email-change-start-process-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './email-change-start-process.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailLinkComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class EmailChangeStartProcessTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<EmailChangeStartProcessTemplateData>;
}

export type EmailChangeStartProcessTemplateData = {
  title: string;
  p1: string;
  p2: string;
  avatar_url: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const EmailChangeStartProcessTemplateMocks: EmailChangeStartProcessTemplateData[] = [
  {
    title: 'Email change request',
    p1: 'Hi Olivia! 👋 We’ve received a request to change your email address. A confirmation message has been sent to your new email address.',
    p2: 'If this change hasn’t been made by you, please contact our support team.',
    avatar_url: 'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
    footer: {
      text: 'Need help?',
      label: 'Contact us',
      href: 'https://auth.recruitee.com/?intercom_open=true',
      target: '_blank',
    },
  },
];
